<template>
  <v-app>
    <div class="tw-bg-blue-light">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
